import { render, staticRenderFns } from "./AddCarpet.vue?vue&type=template&id=55a16b49&"
import script from "./AddCarpet.vue?vue&type=script&lang=js&"
export * from "./AddCarpet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports